let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("h3oFo")]).then(() => parcelRequire('kQUup'));